import { Consignee } from './consignee.model';
import { SimplePackage } from './package.model';
import { Delivery } from './delivery.model';
import { Buyer } from './buyer.model';

export class Order {
  id: string; // uuid.v4
  buyer: Buyer;
  consignee: Consignee;
  delivery: Delivery;
  packages: SimplePackage[];

  constructor(args?: Order) { }
}
